/**
 * @file components/biz/HooksForm/hooks/useFetchData
 * @author sunwen05
 */

import _ from 'lodash';
import {useState, useEffect, useCallback} from 'react';
import {useOriginalCopy} from '@huse/previous-value';

import useFetch from '../fetch';
import {FetchDataAction, FetchOptionsAction} from './interface';

export default (
    actions: any,
    fetchOptionsAction: FetchOptionsAction[],
    fetchDataAction?: FetchDataAction
) => {

    // options
    const [optionsData, setOptionsData] = useState({});
    const customEvent = (savedValue: any, value: any) => {
        const savedValueString = JSON.stringify(savedValue);
        const valueString = JSON.stringify(value);
        return savedValueString === valueString;
    };
    const originalFetchOptionsAction = useOriginalCopy(fetchOptionsAction, customEvent);

    // fetchDataAction
    const {
        formData,
        fetchFormAction,
        fetchFormPayload,
        $onFetchFormRequest,
        $onFetchFormResponse
    } = (fetchDataAction as FetchDataAction || {});

    const {data = {}} = useFetch<object, any>(
        fetchFormAction ? actions[fetchFormAction] : '',
        fetchFormPayload,
        $onFetchFormRequest,
        $onFetchFormResponse,
        () => {},
        !fetchFormAction
    );
    const fetchData = {...formData, ...(data ? data : {})};

    // fetch - options
    const fetchOption = useCallback(async (optionsAction: FetchOptionsAction) => {
        const {name, payload = {}, action, fetchKey, $onFetchOptionsResponse} = optionsAction;
        const res = await actions[action](payload);
        const result = _.isArray(res) ? res : res.result;
        const fetchOptionResult = _.isFunction($onFetchOptionsResponse)
            ? $onFetchOptionsResponse(result) || result : result;

        const optionData = _.map(fetchOptionResult, item => (fetchKey ? {
            value: item[fetchKey[0]],
            label: item[fetchKey[1]]
        } : item));
        return {[name]: optionData};
    }, [actions]);

    useEffect(() => {
        const promiseAll = _.map(originalFetchOptionsAction, optionsAction => fetchOption(optionsAction));
        Promise.all(promiseAll).then((res: any[]) => {
            const result = _.assign({}, ...res);
            setOptionsData(result);
        });
    }, [originalFetchOptionsAction, fetchOption]);

    return {fetchData, optionsData};
};
